import ExcelJS from 'exceljs';

const AdminClockReportExcel = async (reportData: any) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Manual Attendance');

    worksheet.mergeCells('A1:J1');
    worksheet.getCell('A1').value = 'Manual attendance by admin';
    worksheet.getCell('A1').alignment = { horizontal: 'center' };
    worksheet.getCell('A1').font = { size: 16, bold: true };

    const headerRow = 3;
    worksheet.getRow(headerRow).values = [
        'Date',
        'Site',
        'Last Name',
        'First Name',
        'Position',
        'Action',
        'Time',
        'Time Source',
        'Recorded By',
        'Recorded At',
    ];
    worksheet.getRow(headerRow).font = { bold: true };

    const rows: any[] = Array.isArray(reportData) ? reportData : [];

    rows.forEach((row: any) => {
        worksheet.addRow([
            row?.Date ?? '',
            row?.SiteName ?? '',
            row?.LastName ?? '',
            row?.FirstName ?? '',
            row?.Position ?? '',
            row?.Action ?? '',
            // Left as "HH:mm" text so the spreadsheet does not reinterpret it as
            // a date, which is what happens to bare times in Excel.
            row?.RecordedTime ?? '',
            row?.TimeSource ?? '',
            row?.PerformedBy ?? '',
            row?.PerformedAt ?? '',
        ]);
    });

    // Enough width to read without hand-sizing every column.
    worksheet.columns.forEach((column, index) => {
        // "Recorded By" now carries a name and the email, so it needs the room.
        column.width = [12, 28, 18, 16, 20, 11, 9, 14, 42, 20][index] ?? 16;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    return buffer;
};

export default AdminClockReportExcel;
